import React from 'react'
import {withRouter, Link} from 'react-router-dom'
import reactDisplayHtml from 'utils/react-display-html'
import getDate from 'utils/get-date'
import Main from '../../Main'

// if (props.type === 'video') {
//   video = <iframe title="wv-adp-video" style={{width: '100%'}} width="854" height="480" src={props.content} frameBorder="0" gesture="media" allow="encrypted-media" allowFullScreen></iframe>
// }

const MyUpdatesSingle = props => {
  let content = ''

  if (props.community !== undefined && props.community !== '') {
    content = props.community
    let video = ''
    if(content.video !==''){
      video = <iframe title="wv-adp-video" style={{width: '100%'}} width="854" height="480" src={props.content} frameBorder="0" gesture="media" allow="encrypted-media" allowFullScreen></iframe>
    }

    content = <div>
      <h1>{content.title}</h1>
      <div className="release-date">{getDate(content.created_at)}</div>
      <div className="timeline-body" dangerouslySetInnerHTML={reactDisplayHtml(content.content)}>
      </div>
      <div>
        {video}
      </div>
    </div>
  } else {
    content = 'No available updates.'
  }

  return (
    <Main>
      <div className="island">
        {content}
        <br />
        <Link className="btn" to="/dashboard/my-updates">
          <i className="fa fa-chevron-left" aria-hidden="true"></i> Go back
        </Link>
      </div>
    </Main>
  )
}

MyUpdatesSingle.defaultProps = {
  community: ''
}

export default withRouter(MyUpdatesSingle)
